import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStatus, masterTenantId, tenantId } from '../../../../api/client';
import GridLoader from '../../../../component/Controls/loaders/gridLoader';
import { addWorkspace, createNewCompany, getAllCompanies, getCompanyById, removeStatus, selectAddWorkspaceStatus, selectAllCompanies, selectCreationStatus, selectModificationStatus, selectRemovalStatus, selectStatus, showCompanyFlyout, updateSingleData, updateStatus } from '../../reducerSlices/companySlice';
import ReactPlaceholder from 'react-placeholder';
import { Filter, GridComponent, Inject, Page, Sort, Resize, Toolbar, CommandColumn } from '@syncfusion/ej2-react-grids';
import ReactTooltip from 'react-tooltip';
import { messages } from '../../../../common/actionMessages';
import { show } from '../../../../component/Controls/alerts/reducerSlices/confirmAlertSlice';
import { isObjectArray } from '../../../../utilities/utilityFunctions';
import { AccountPlan } from '../../../../common/constants';

function Company() {
    const whereClause = {
        name: ""
    };
    const dispatch = useDispatch();

    const [dummyCards, setDummyCards] = useState([]);

    const statusCreationStatus = useSelector(selectCreationStatus);
    const statusModificationStatus = useSelector(selectModificationStatus);
    const statusesRemovalStatus = useSelector(selectRemovalStatus);

    const statuses = useSelector(selectAllCompanies);

    const statusesRequestStatus = useSelector(selectStatus);

    const addWorkspaceStatus = useSelector(selectAddWorkspaceStatus);


    useEffect(() => {
        if (addWorkspaceStatus === fetchStatus.SUCCEEDED ) {
            _loadCompanies();
        }
    }, [addWorkspaceStatus]);

    useEffect(() => {
        if (statusesRequestStatus === fetchStatus.IDLE) {
            _loadCompanies();
        }
    }, [statusesRequestStatus, dispatch]);

    let _dummyCards = [];

    useEffect(() => {
        if (statusesRequestStatus === fetchStatus.SUCCEEDED) {
            dispatch(updateStatus());
        }
    }, [statusesRequestStatus]);

    useEffect(() => {
        if (statusesRequestStatus === fetchStatus.LOADING) {
            for (let i = 0; i < 10; i++) {
                _dummyCards.push(
                    <div className="list-loading-content">
                        <ReactPlaceholder type='text' ready={false} rows={2} color='#E0E0E0'>
                        </ReactPlaceholder>
                    </div>
                );
            }
            setDummyCards(_dummyCards);
        }
    }, [statusesRequestStatus]);

    useEffect(() => {
        if (statusesRemovalStatus === fetchStatus.SUCCEEDED) {
            _loadCompanies();
            if (statuses && statuses.Items && statuses.Items.length > 0) {
                let item = statuses.Get(0);
                let _statuses = item ? item.records : [];
                if (_statuses && Array.isArray(_statuses) && _statuses.length > 0) {
                    let _status = _statuses[0];
                    if (_status && _status.id) {
                        _loadStatus(_status.id, 0);
                    }
                }
                else {
                    dispatch(updateSingleData(undefined));
                }
            }
            else {
                dispatch(updateSingleData(undefined));
            }
        }
    }, [statusesRemovalStatus]);

    const _loadStatus = async (id, page) => {
        await dispatch(getCompanyById({
            page: page,
            model: {
                client: tenantId,
                serviceType: "TENANTADMIN",
                operation: "GETSETTINGCOMPANYMASTERBYID",
                payload: {
                    id: id,
                    data: ""
                }
            }
        }));
    }

    // const _loadForm = async () => {
    //     await dispatch(getClientForm({
    //         client: tenantId,
    //         serviceType: "TENANTADMIN",
    //         operation: "GETFORMBYTYPE",
    //         payload: {
    //             id: "",
    //             data: "ClientForm"
    //         }
    //     }));
    // }

    const _loadCompanies = async () => {
        await dispatch(getAllCompanies({
            page: 0,
            model: {
                client: tenantId,
                serviceType: "TENANTADMIN",
                operation: "GETSETTINGCOMPANYMASTERS",
                payload: {
                    id: "",
                    data: ""
                }
            }
        }));

    }

    const onCompanySelected = (e, id) => {
        e.preventDefault();
        _loadStatus(id, undefined);
        dispatch(showCompanyFlyout({
            createMode: false,
            editMode: true
        }));
    };

    const onDeleteClicked = (e, id) => {
        e.preventDefault();
        if (id) {
            dispatch(show({
                id: id,
                title: messages.confirmAlert.title,
                content: messages.confirmAlert.content.removal('Status'),
                confirmedCallback: _removeStatus
            }));
        }
    };

    const onAddRecordClicked = (e) => {
        dispatch(createNewCompany());

        dispatch(showCompanyFlyout({
            createMode: true,
            editMode: false
        }));
    };

    const _removeStatus = async (id) => {
        await dispatch(removeStatus({
            client: tenantId,
            serviceType: "TENANTADMIN",
            operation: "DELETESTATUS",
            payload: {
                id: id,
                data: ""
            }
        }))
    };

    useEffect(() => {
        if (statusCreationStatus === fetchStatus.SUCCEEDED) {
            _loadCompanies(0, 0, 10, whereClause);
        }
    }, [statusCreationStatus]);

    useEffect(() => {
        if (statusModificationStatus === fetchStatus.SUCCEEDED) {
            _loadCompanies(0, 0, 10, whereClause);
        }
    }, [statusModificationStatus]);

    const _geStatusText = (statuses, id) => {
        if (isObjectArray(statuses)) {
            let _statuse = statuses.find(l => l.id === id);
            if (_statuse && _statuse.StatusName) {
                return _statuse.StatusName;
            }
        }
        return "";
    }

    const _geStatusText2 = (statuses, id) => {
        if (isObjectArray(statuses)) {
            let _statuse = statuses.find(l => l.value === id);
            if (_statuse && _statuse.text) {
                return _statuse.text;
            }
        }
        return "";
    }


    const getPlanText = (field, data, column) => {
        let _plan = data["Plan"]
        return AccountPlan[_plan];
    }

    const getIsCompanySetupText = (field, data, column) => {
        let _isCompanySetup = data["IsCompanySetup"];

        return _isCompanySetup === false ? 'Pending' : 'Completed';

    }

    const getIsWorkspaceUrlSetupText = (field, data, column) => {
        let _isCompanySetup = data["IsWorkspaceUrlSetup"];

        return _isCompanySetup === false ? 'Pending' : 'Completed';

    }

    const addActionTemplate = (props) => {
        return <>
            <i className='fa fa-pencil' data-tip='Edit' title='Edit' onClick={(e) => onCompanySelected(e, props.id)}></i>
            {props.IsWorkspaceUrlSetup === false &&
                <i className='fa-solid fa-globe ms-3' data-tip='Create Workspace' title='Create Workspace' onClick={(e) => onAddSubDomainClicked(e, props)}></i>
            }
            {/* {props.isDefaultStatusName
                
                <></>
                :
                <i className='fa fa-trash ps-3' data-tip='Delete' onClick={(e) => onDeleteClicked(e, props ? props.id : "")}></i>
            } */}
            <ReactTooltip place="bottom" type="info" effect="solid" className="c-tooltip" arrowColor='#0a253e' />
        </>
    }
    const gridRef = useRef(null);
    useEffect(() => {
        if (gridRef.current) {
            gridRef.current.refresh();
        }
    }, [statuses, statusesRequestStatus]);

    const columns = [
        { field: 'CompanyName', headerText: 'Company Name', width: '100' },
        { field: 'CompanyPhoneNumber', headerText: 'Company Phone Number', width: '100' },
        { field: 'WorkspaceURL', headerText: 'Workspace Name', width: '100' },
        { field: 'Plan', headerText: 'Plan', width: '100', valueAccessor: getPlanText },
        { field: 'Status', headerText: 'Status', width: '100' },
        { field: 'IsWorkspaceUrlSetup', headerText: 'Workspace Url Setup', width: '100', valueAccessor: getIsWorkspaceUrlSetupText },
        { field: 'IsCompanySetup', headerText: 'Company Setup', width: '100', valueAccessor: getIsCompanySetupText },
        {
            headerText: 'Action',
            template: addActionTemplate,
            width: '50px',
        },
    ];

    const _createSubDomain = (id) => {
        if (id) {
            dispatch(addWorkspace({
                client: masterTenantId,
                serviceType: "TENANTADMIN",
                operation: "ADDWORKSPACE",
                payload: {
                    id: id
                }
            }));
        }
    }

    const onAddSubDomainClicked = (e, props) => {
        e.preventDefault();

        if (props.id) {
            dispatch(show({
                id: props.id,
                title: <><span>Add subdomain for </span> <span className="modal-header-name">{props.CompanyName ? props.CompanyName : "N/A"}</span></>,
                content: <>Are you sure you want to create the subdomain <strong className='text-rust'>{props.WorkspaceURL}.hirebase.com</strong> ?</>,
                confirmedCallback: _createSubDomain
            }));
        }
    }

    return (
        <>
            {(statusesRequestStatus === fetchStatus.LOADING ||
                statusesRemovalStatus === fetchStatus.LOADING ||
                addWorkspaceStatus === fetchStatus.LOADING
            ) &&
                <div className="app-container-loader">
                    <GridLoader />
                </div>}
            <div className="row">
                <div className="col-md-6">
                    <span className="detail-container-title">Company</span>
                </div>
                {/* <div className="col-md-6 text-end">
                    <button className="c-btn dark-btn" type="button" data-tip='Create new company' onClick={(e) => onAddRecordClicked(e)}>
                        <i className="fa fa-plus"></i>
                    </button>
                </div> */}
            </div>
            <div className="row p-3">
                <GridComponent ref={gridRef} dataSource={statuses} allowPaging={true} allowSorting={true} allowResizing={true} width="100%" toolbar={['Search']} pageSettings={{ pageSize: 10, pageCount: 5 }} rowHeight={50} columns={columns} >
                    <Inject services={[Page, Sort, Filter, Resize, Toolbar, CommandColumn]} />
                </GridComponent>
            </div>
        </>
    )
}

export default Company;